import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { defaultIfEmpty, firstValueFrom } from 'rxjs';
import { DialogOptions } from '@lib/util';
import {
    PurchasingGroupSettingsComponent,
    PurchasingGroupSettingsDialogResult,
} from './purchasing-group-settings.component';

@Component({
    selector: 'lib-purchasing-group-settings-route',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './purchasing-group-settings-route.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PurchasingGroupSettingsRouteComponent implements OnInit {
    private readonly dialog = inject(MatDialog);
    private readonly router = inject(Router);

    public async ngOnInit(): Promise<void> {
        const dialogRef = this.dialog.open<
            PurchasingGroupSettingsComponent,
            undefined,
            PurchasingGroupSettingsDialogResult
        >(PurchasingGroupSettingsComponent, DialogOptions.SMALL());

        await firstValueFrom(dialogRef.afterClosed().pipe(defaultIfEmpty(undefined)));
        await this.router.navigate(['/client/system'], { replaceUrl: true });
    }
}
